import React from "react";
import styles from "./chartPopup.module.css";
import { TQuestionData } from "../../../services/types/user.types";
import Chart from "../chart/chart";

interface ChartPopupProps {
    data: TQuestionData;
    total: number;
    color?: string;
    setDataToAnalyze: (data: TQuestionData[]) => void;
    onClose: () => void;
}

const ChartPopup: React.FC<ChartPopupProps> = ({
    data,
    total,
    color,
    setDataToAnalyze,
    onClose,
}) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <button className={styles.closeBtn} onClick={onClose}>✕</button>
                <div className={styles.chartContainer}>
                    <Chart data={data} total={total} color={color} setDataToAnalyze={setDataToAnalyze} isPopup={true} />
                </div>
            </div>
        </div>
    );
};

export default ChartPopup;